/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Saving fetches the package on the worker and checks its manifest, which can take a moment for a large package." |
*
* @param {Partner_Connectors_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_dialog_description = /** @type {((inputs?: Partner_Connectors_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Speichern lädt der Worker das Paket und prüft sein Manifest. Bei einem großen Paket kann das einen Moment dauern.")
	return /** @type {LocalizedString} */ ("Saving fetches the package on the worker and checks its manifest, which can take a moment for a large package.")
});